<template>
  <div>
    <el-form :model="form">
      <el-form-item
        label="管理员账号"
        prop="account"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员账号"
          v-model="form.account"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="密码"
        prop="password"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员账号密码"
          v-model="form.password"
          autocomplete="off"
          class="input"
          v-if="type==='add'"
        />
        <el-input
          placeholder="如果不修改请传空"
          v-model="form.password"
          autocomplete="off"
          class="input"
          v-if="type==='edit'"
        />
      </el-form-item>
      <el-form-item
        label="姓名"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员姓名"
          v-model="form.name"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="联系方式"
        prop="user_mobile"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员联系方式"
          v-model="form.mobile"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="管理员身份"
        prop="group_id"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="form.group_id"
          class="input"
        >
          <el-option
            v-for="item in identTable"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-button
        type="primary"
        class="saveBth"
        @click="onSaveClick"
      >保存</el-button>
    </el-form>
  </div>
</template>

<script>
import {
  identityOf,
  getAuthListDetail,
  addAdminUser,
  editAuthUser
} from "@/api/auth";
import { mapState } from "vuex";

export default {
  name: "handleadmin",
  data() {
    return {
      formLabelWidth: "120px",
      form: {
        name: "",
        mobile: "",
        account: "",
        password: "",
        group_id: ""
      },
      type: "add",
      identTable: [] //身份列表
    };
  },
  components: {},
  async mounted() {
    await this.getIdentityList();
    const { uuid } = this.$route.query;
    if (uuid) {
      this.type = "edit";
      this._getAuthListDetail(uuid);
    } else {
      this.type = "add";
      this.form = {
        name: "",
        mobile: "",
        account: "",
        password: "",
        group_id: ""
      };
    }
  },
  computed: {
    ...mapState(["loginData"])
  },
  methods: {
    async _getAuthListDetail(uuid) {
      const {
        data: { result: resData },
        status
      } = await getAuthListDetail(uuid);
      if (status === 200) {
        resData.password = "";
        resData.group_id = resData.group.id + "";
        this.form = resData;
        console.log(resData, "detail");
      }
    },
    async getIdentityList() {
      let postData = {
        page_index: 1,
        page_size: 99
      };
      const {
        data: { result: resData },
        status
      } = await identityOf(postData);
      if (status !== 200) return;
      if (resData.data.length) {
        //身份id是数字类型的 管理员列表对应group_id 是字符串类型。 这一步是把id变为字符串类型已匹配group_id
        resData.data.forEach(item => {
          item.id += "";
        });
      }
      console.log(resData, "identi");
      this.identTable = resData.data;
    },
    hotelDialogConfirm(hotels) {
      this.hotel_uuid = hotels.map(hotel => hotel.uuid);
      this.selectHotel = hotels;
      this.hotelDialogVisible = false;
    },
    async onSaveClick() {
      const { name, mobile, account, group_id, password } = this.form;
      if (!account) {
        this.$message("请输入管理员账号");
        return;
      }
      if (this.type === "add" && !password) {
        this.$message("请输入密码");
        return;
      }
      if (!name) {
        this.$message("请输入管理员姓名");
        return;
      }
      if (!mobile) {
        this.$message("请输入联系方式");
        return;
      }
      if (!group_id) {
        this.$message("请选择管理员身份");
        return;
      }
      let resStatus;
      if (this.type === "add") {
        ({ status: resStatus } = await addAdminUser(this.form));
      } else {
        ({ status: resStatus } = await editAuthUser(this.form));
      }
      if (resStatus === 200) {
        this.$router.go(-1);
      }
    },
    async _getHotelList() {
      const postData = {
        page_size: 9999,
        page_index: 1
      };
      //如果是超级管理员 查询所有数据
      if (this.loginData.group.is_admin === "2") {
        postData.admin_type = "1";
      }
      const { status, data } = await getHotelList(postData);
      if (status === 200) {
        this.hotelList = data.data;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.input {
  width: 300px;
}
.select-hotel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px;
  box-shadow: 0px 2px 8px 0px rgba(26, 66, 70, 0.1);
  .item {
    margin-right: 20px;
  }
}
.selectBth {
  display: block;
  margin-top: 20px;
}
.saveBth {
  display: block;
  margin: 50px auto 0;
}
</style>
